import { create } from 'zustand';
import ServiceEmpregadores from '@/services/ServiceEmpregadores';
import { notify } from '@/stores/useToast';

type Empregador = any;

// Normaliza a company da view (/agnes/companies) p/ o contrato que as telas de encargos
// usam (company/socialName/fantasyName/cnpjFilial/cnpjMatriz), herdado do domínio antigo.

const normalizar = (e: any): Empregador => ({
  id: e.id,
  cnpjFilial: e.cnpj,
  cnpjMatriz: e.nrinsc, // raiz 8 dígitos
  company: e.razaoSocial,
  socialName: e.razaoSocial,
  fantasyName: e.nomeFantasia,
  city: e.municipio,
  stateCode: e.uf,
  // Certificado digital por empresa ("RAZÃO:CNPJ"), setado manualmente via tenant-provider.
  // Alimenta o header certificate-name das coletas e-CAC (sem cert fixo hardcoded).
  certificado: e.certificateName ?? '',
});

interface State {
  lista: Empregador[];
  carregando: boolean;
  buscar: () => Promise<void>;
}

export const useEmpregadoresStore = create<State>((set) => ({
  lista: [],
  carregando: false,
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceEmpregadores.listar();
      const arr = Array.isArray(data) ? data : (data.content ?? []);
      set({ lista: arr.map(normalizar) });
    } catch {
      notify.error('Erro ao buscar empregadores.');
    } finally {
      set({ carregando: false });
    }
  },
}));
